import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Section, Title } from "@/components/UI";
import { ProviderSection } from "@/components/contacting";
import { useRefsContext } from "@/contexts/ref";
import { useI18n, useIsNewBuildProject } from "@/shared/hooks";
import { useContactSections } from "@/contexts/contact";
export const PropertyProvider = () => {
    var _a;
    const isProject = useIsNewBuildProject();
    const { t } = useI18n();
    const { propertyProviderRef } = useRefsContext();
    const isPrivateOwner = (_a = useContactSections()) === null || _a === void 0 ? void 0 : _a.contactCard.isPrivateOwner;
    let title;
    if (isProject) {
        title = t("contact.provider.project.property_provider");
    }
    else {
        title = isPrivateOwner
            ? t("provider.title_owner")
            : t("provider.title_agency");
    }
    return (_jsxs(Section, { ref: propertyProviderRef, children: [_jsx(Title, { variant: "section", title: title, id: "propertyProvider" }), _jsx(ProviderSection, {})] }));
};
